export enum CsvJobStateEnum {
  PENDING = "pending",
  QUEUED = "queued",
  ERROR = "error",
}

export enum CsvJobNameEnum {
  TEAM_USERS = "team_users_csv_job",
  PROJECTS = "provider_leads_csv_job",
  EARNINGS_ANALYTICS = "earnings_intelligence_report_job",
  TEAM_INTELLIGENCE = "team_intelligence_csv_job",
}

export enum CsvJobNameKeyEnum {
  TEAM_USERS = "teamUsersCsvJob",
  PROJECTS = "providerLeadsCsvJob",
  EARNINGS_ANALYTICS = "earningsIntelligenceReportJob",
  TEAM_INTELLIGENCE = "teamIntelligenceCsvJob",
}

export enum CsvReportNameEnum {
  TEAM_USERS = "SellerTeamUsersCSV",
  ORG_TEAM_USERS = "OrgTeamUsersCSV",
  TEAM_AMBASSADORS = "AmbassadorUsersCSV",
  ORG_TEAM_SEATED_USERS = "OrgTeamSeatedUsersCSV",
  ORG_PRE_SALES_PROJECTS = "OrgPreSalesProjectsCSV",
  ORG_POST_SALES_PROJECTS = "OrgPostSalesProjectsCSV",
  ORG_COMPLETED_PROJECTS = "OrgCompletedProjectsCSV",
  EARNINGS_ANALYTICS = "EarningsAnalyticsCSV",
  TEAM_INTELLIGENCE = "TeamIntelligenceCSV",
}

export const EARNINGS_ANALYTICS_CSV_NAME_PREFIX = "EarningsIntelligence-";
